import React, { useState, useEffect } from "react";

function Back_ID({setPay, setStk, setFillin, setDoc, setBackid, setFrontid, setCv, ms}) {
    const [selectedImage, setSelectedImage] = useState();
    const [next, setNext] = useState(false)

    const next_btn = () =>{
       setCv(true)
       setBackid(false)
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          const imageUrl = URL.createObjectURL(file);
          setSelectedImage(imageUrl);
          setNext(true)
        }
      };
  return (
    <div className='property_doc_Inner'>
    <div className='docs'>

        <div className='img_Disp'><img src={selectedImage} /></div>

        <div className='label_DIV'><label className='img_label' htmlFor="file-upload">Click to choose back ID pic</label></div>
        <input className='choose_img' accept="image/jpeg, image/jpg"  id="file-upload"  type='file' onChange={handleImageChange} />

        {next?(<div onClick={next_btn} className='submit'>Next</div>):('')}

    </div>
</div>
  )
}

export default Back_ID